export const DEVICE_TYPE = {
  mobile: 'mobile',
  desktop: 'desktop',
} as const;

export type DeviceType = (typeof DEVICE_TYPE)[keyof typeof DEVICE_TYPE];

export const isMobileDevice = (userAgent: string = navigator.userAgent): boolean =>
  /Mobile/i.test(userAgent);

export const getDeviceType = (): DeviceType =>
  isMobileDevice() ? DEVICE_TYPE.mobile : DEVICE_TYPE.desktop;

export const IS_MAC_OS: boolean =
  typeof navigator !== 'undefined' && /Mac OS X/.test(navigator.userAgent);
